import React from "react";
import LegalPage from "../components/LegalPage";
export default function PrivacyPolicy() {
  return <LegalPage tKey="privacy" testid="privacy-page" />;
}
